import React from 'react';

const IntegrationsHeader = ({ user }) => {
  // Don't render if user is not loaded yet
  if (!user || !user.user) {
    return (
      <div className="integrations-header">
        <div className="header-content">
          <h1>Integration Management</h1>
          <div className="user-info">
            <span>Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="integrations-header">
      <div className="header-content">
        <h1>Integration Management</h1>
        <div className="user-info">
          <span>{user.user.email}</span>
          <span className="tenant-badge">{user.user.tenant_code}</span>
        </div>
      </div>
    </div>
  );
};

export default IntegrationsHeader; 